export const ScopesTableHelpers = {
    data() {
        return {
            tableColumns: [
                ['OICC', 'OEYC', 'OENY', 'OCLN', 'OCPR', 'OCPE', 'OINSP', 'OCSG', 'CSIA', 'CSA', 'CSGAS'].includes(this.activity) ? {
                    title: ['OICC', 'OEYC', 'OENY', 'OCLN', 'OCPR', 'OCPE', 'OINSP', 'OCSG', 'CSIA', 'CSA', 'CSGAS'].includes(this.activity) ? 'Actividad' : 'Nivel 1',
                    type: 'custom-html',
                    key: 'accreditation_application',
                    modifier: (item) => {
                        return item;
                    }
                } : {},
                ['OICC', 'OEYC', 'OENY', 'OCLN', 'OCLN', 'OCPR', 'OCPE', 'OINSP', 'OCSG', 'CSIA', 'CSA', 'CSGAS'].includes(this.activity) ? {
                    title: ['OICC', 'OEYC', 'OENY', 'OCLN', 'OCPR', 'OCPE', 'OCSG', 'CSIA', 'CSA', 'CSGAS'].includes(this.activity) ? 'Sector' : 'Nivel 2',
                    type: 'custom-html',
                    key: 'accreditation_application',
                    modifier: (item) => {
                        return item.accreditation_activity.name;
                    }
                } : {},
                ['OICC', 'OEYC', 'OENY', 'OCLN', 'OINSP'].includes(this.activity) ? {
                    title: ['OICC'].includes(this.activity) ? 'Campo de ensayo'
                        : ['OEYC', 'OENY'].includes(this.activity) ? 'Área metrológica/Campo'
                            : ['OCLN'].includes(this.activity) ? 'Campo de análisis'
                                : ['OINSP'].includes(this.activity) ? 'Tipo de inspección o metodología'
                                    : 'Nivel 3',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.description;
                    }
                } : {},
                ['OICC', 'OCLN'].includes(this.activity) ? {
                    title: ['OICC', 'OCLN'].includes(this.activity) ? 'Técnica' : 'Nivel 4',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.description;
                    }
                } : {},
                ['OICC', 'OEYC', 'OENY', 'OCLN', 'OCPR', 'OCPE', 'OINSP', 'OCSG', 'CSIA', 'CSA', 'CSGAS'].includes(this.activity) ? {
                    title: ['OICC'].includes(this.activity) ? 'Ensayo'
                        : ['OEYC', 'OENY'].includes(this.activity) ? 'Magnitud submagnitud'
                            : ['OCLN'].includes(this.activity) ? 'Análisis'
                                : ['OCPR'].includes(this.activity) ? 'Producto ,proceso o servicio'
                                    : ['OCPE'].includes(this.activity) ? 'Personal certificado'
                                        : ['OINSP'].includes(this.activity) ? 'Campo de inspección'
                                            : ['OCSG', 'CSIA', 'CSA', 'CSGAS'].includes(this.activity) ? 'Categoría'
                                                : 'Nivel 5',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.description;
                    }
                } : {},
                ['OICC', 'OEYC', 'OENY', 'OCLN', 'OCPE', 'OINSP', 'OCSG', 'CSIA', 'CSA', 'CSGAS'].includes(this.activity) ? {
                    title: ['OICC'].includes(this.activity) ? 'Producto o material a ensayar'
                        : ['OEYC', 'OENY'].includes(this.activity) ? 'Tipos  Instrumentos a calibrar'
                            : ['OCLN'].includes(this.activity) ? 'Muestra'
                                : ['OCPR'].includes(this.activity) ? 'Categoría de producto, proceso o servicio'
                                    : ['OCPE'].includes(this.activity) ? 'Categoría de personal'
                                        : ['OINSP'].includes(this.activity) ? 'Elemento a inspeccionar'
                                            : ['OCSG', 'CSIA', 'CSA', 'CSGAS'].includes(this.activity) ? 'Campo de certificación Sector IAF'
                                                : 'Nivel 6',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.description;
                    }
                } : {},
                ['OICC', 'OEYC', 'OENY', 'OCLN'].includes(this.activity) ? {
                    title: ['OICC', 'OEYC', 'OENY'].includes(this.activity) ? 'Rango'
                        : ['OCLN'].includes(this.activity) ? 'Método'
                            : 'Nivel 7',
                    type: 'text',
                    key: 'level7',
                } : {},
                ['OEYC', 'OENY'].includes(this.activity) ? {
                    title: ['OEYC', 'OENY'].includes(this.activity) ? 'Incertidumbre' : 'Nivel 8',
                    type: 'text',
                    key: 'level8',
                } : {},
            ],
            actionObj: {
                title: '',
                type: 'action',
            }
        }
    },
}